import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ContactCTA from '../../components/home/ContactCTA';
// partner logo import removed (not used in this page)
import heroImg from '../../assets/images/htw-cartridge-mold.jpg';
import middleImg from '../../assets/images/htw-23a.jpg';
import heroSlider from '../../assets/images/htw-hero-slider.jpg';
import imgP1 from '../../assets/images/Injection-molding-machine.png';
import imgP2 from '../../assets/images/Pet-beverage-filling-line.png';
import imgP3 from '../../assets/images/pet-preforn-mold.png';
import imgP4 from '../../assets/images/PET-material-lab-equipment.jpg';
import imgP5 from '../../assets/images/integratedplastic.jpg';
import imgP6 from '../../assets/images/caps-closures-mold.jpg';
import imgP7 from '../../assets/images/Medical-pharma-paxkaging-mold.jpg';
import imgP8 from '../../assets/images/Packaging&Systems.jpg';

const Htw = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, 100);
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }, []);

  const navigate = useNavigate();
  const handleNavigation = (path) => navigate(path);

  const suggestedProducts = [
    { title: 'Injection Molding Machine', image: imgP1, path: '/products/injection-molding', description: 'Precision injection molding equipment for plastic product manufacturing.' },
    { title: 'Beverage Filling Line', image: imgP2, path: '/products/beverage-filling', description: 'Complete automated beverage production solutions with high-speed filling capabilities.' },
    { title: 'PET Preform Molds', image: imgP3, path: '/products/pet-preform', description: 'High-precision molds for PET preform production with exceptional durability.' },
    { title: 'Lab Equipment', image: imgP4, path: '/products/lab-equipment', description: 'Advanced laboratory testing and analysis equipment for quality control.' },
    { title: 'Exclusive Applications', image: imgP5, path: '/products/integrated-plastics', description: 'Integrated plastics solutions for market-ready container applications.' },
    { title: 'Caps & Closures Mold', image: imgP6, path: '/products/caps-mold', description: 'Specialized molds for producing high-quality caps and closures.' },
    { title: 'Packaging Mold', image: imgP7, path: '/products/packaging-mold', description: 'Precision manufacturing molds for diverse packaging applications.' },
    { title: 'Packaging & Systems', image: imgP8, path: '/products/packaging-systems', description: 'Advanced packaging systems for end-to-end product handling and finishing.' }
  ];

  return (
    <>
      {/* Hero */}
      <section
        className="relative text-white h-64 sm:h-80 md:h-96 mt-20 sm:mt-12"
        style={{
          backgroundImage: `url(${heroSlider})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
        }}
      >
        <div className="absolute inset-0 bg-black/40" />
        <div className="container mx-auto px-4 h-full flex items-center">
          <div className="text-white">
            <h1 className="text-3xl md:text-4xl font-bold text-blue-600">Cartridge Moulds</h1>
            <p className="mt-2 max-w-2xl">High-precision cartridge moulds for silicon and grease cartridges. Engineered for superior filling quality and fast cycle times.</p>
            <div className="mt-4">
              <a href="/contact" className="inline-block bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded text-sm">Know More</a>
            </div>
          </div>
        </div>
      </section>

      {/* Overview */}
      <section className="py-12">
        <div className="container mx-auto px-4">
          <div className="mb-8">
            <h2 className="text-2xl font-bold mb-4 text-blue-600">Overview</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              HTW cartridge moulds bring more than 30 years of mould-making expertise to high-precision silicone and grease cartridge production. Built for demanding filling applications, these moulds deliver far better flow control, surface finish, and final part quality than standard alternatives.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              With optimized valve gate systems and carefully engineered cooling, HTW cartridge moulds are designed for reliable production of closure systems, cosmetic cartridges, and specialty grease containers.
            </p>
            <div className="bg-gray-50 p-6 rounded-lg shadow-sm border border-gray-200">
              <h3 className="text-lg font-semibold mb-3 text-blue-600">Performance Highlights</h3>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>High repeatability that supports low scrap and stable part dimensions.</li>
                <li>Advanced valve-gate design for balanced filling and reduced hesitation.</li>
                <li>Flexible cavity layouts to support 2–16 silicon cartridges and 2–8 grease cartridges.</li>
                <li>Fast cycle capability for high-speed production lines.</li>
              </ul>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white p-6 rounded-lg shadow">
              <h3 className="text-xl font-semibold mb-3 text-blue-600">Key Features</h3>
              <ul className="list-disc list-inside text-gray-700 space-y-2">
                <li>Silicon cartridge moulds: 2, 4, 6, 8, 12, 16 cavities</li>
                <li>Grease cartridge moulds: 2, 4, 6, 8 cavities</li>
                <li>Cycle time (silicon): ~10-12 seconds</li>
                <li>Cycle time (grease): ~12-14 seconds</li>
                <li>Valve-gate system for improved filling and part quality</li>
                <li>Designed for high precision and consistent results</li>
              </ul>
            </div>

            <div className="bg-white p-6 rounded-lg shadow">
              <h3 className="text-xl font-semibold mb-4 text-blue-600">Typical Applications</h3>
              <p className="text-gray-700 mb-3">Suitable for high-quality closures and cartridges used in cosmetics, pharmaceuticals, and industrial grease packaging.</p>
              <Link to="/contact" className="inline-block bg-green-600 hover:bg-green-700 text-white px-3 py-1.5 rounded text-sm">Know More</Link>
            </div>
          </div>

          <div className="mt-10">
            <h3 className="text-xl font-semibold mb-4 text-blue-600">Technology</h3>
            <p className="text-gray-700 leading-relaxed mb-4">HTW cartridge moulds combine robust steel construction with precisely controlled valve gate actuation. This enables stable melt flow, excellent surface appearance, and consistent cavity filling even with challenging silicon and grease formulations.</p>

            <h3 className="text-xl font-semibold mb-4 text-blue-600">Key Features</h3>
            <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4">
              <li>Silicon cartridge moulds available in 2, 4, 6, 8, 12 and 16 cavities.</li>
              <li>Grease cartridge moulds available in 2, 4, 6 and 8 cavities.</li>
              <li>Cycle time range from 10 to 14 seconds depending on material and mould layout.</li>
              <li>Advanced valve gate layout for uniform filling and reduced knit lines.</li>
              <li>Optimized cooling for rapid cycle recovery and minimal thermal distortion.</li>
            </ul>

            <h3 className="text-xl font-semibold mb-4 text-blue-600">Benefits</h3>
            <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4">
              <li>Greater part consistency and reduced reject rates.</li>
              <li>Improved filling quality that supports premium packaging applications.</li>
              <li>Lower production cost through reduced material waste and faster cycles.</li>
              <li>Adaptable mould geometry for new cartridge designs and formats.</li>
            </ul>

            <h3 className="text-xl font-semibold mb-4 text-blue-600">Applications & Gallery</h3>
            <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              <img src={heroImg} alt="HTW cartridge 1" className="w-full h-44 object-cover rounded shadow-sm" />
              <img src={middleImg} alt="HTW cartridge middle" className="w-full h-44 object-cover rounded shadow-sm" />
              <img src={imgP3} alt="Production line" className="w-full h-44 object-cover rounded shadow-sm" />
            </div>
          </div>

          {/* Specs / Gallery */}
          <div className="mt-10">
            <h3 className="text-xl font-semibold mb-4 text-blue-600">Specification Highlights</h3>
            <div className="bg-white rounded shadow-sm overflow-hidden">
              <table className="w-full text-sm text-gray-700">
                <tbody>
                  <tr className="border-b">
                    <td className="px-4 py-3 font-semibold w-1/3">Silicon cartridges</td>
                    <td className="px-4 py-3">2, 4, 6, 8, 12, 16 cavities</td>
                  </tr>
                  <tr className="border-b">
                    <td className="px-4 py-3 font-semibold">Cycle time (silicon)</td>
                    <td className="px-4 py-3">10-12 seconds</td>
                  </tr>
                  <tr className="border-b">
                    <td className="px-4 py-3 font-semibold">Grease cartridges</td>
                    <td className="px-4 py-3">2, 4, 6, 8 cavities</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-3 font-semibold">Cycle time (grease)</td>
                    <td className="px-4 py-3">12-14 seconds</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              <img src={heroImg} alt="HTW cartridge 1" className="w-full h-40 object-cover rounded" />
              <img src={middleImg} alt="HTW cartridge middle" className="w-full h-40 object-cover rounded" />
              <img src={imgP3} alt="HTW cartridge mold" className="w-full h-40 object-cover rounded" />
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
        <div className="container mx-auto px-6 max-w-7xl">
          <div className="text-center mb-16">
            <div className="inline-block">
              <span className="text-sm font-semibold text-blue-600 uppercase tracking-wider mb-2 block">
                Explore More
              </span>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
                Other Suggested Products
              </h2>
              <div className="w-24 h-1 bg-gradient-to-r from-blue-600 to-green-600 mx-auto mb-6"></div>
            </div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Discover our comprehensive range of cutting-edge industrial solutions designed to optimize your production efficiency and enhance manufacturing capabilities.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
            {suggestedProducts.map((product) => (
              <div
                key={product.title}
                onClick={() => handleNavigation(product.path)}
                className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 cursor-pointer overflow-hidden border border-gray-100"
              >
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={product.image}
                    alt={product.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-green-600 transition-colors duration-300">
                    {product.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed mb-4">
                    {product.description}
                  </p>
                  <div className="flex items-center text-green-600 font-semibold group-hover:translate-x-2 transition-transform duration-300">
                    <span>Learn More</span>
                    <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <ContactCTA />
    </>
  );
};

export default Htw;
